import { events, partners } from '../../../services/api.admin';
import { apiActionCreator } from '../../helpers';
import { openFlash } from '../flash';
import { MODELS } from '../../../constants/admin/settings';
import { setModelData } from '../forms';
import { fetchDependencies } from '../modal.forms';

export const FETCH_CATEGORY_CONFIG_REQUEST = 'FETCH_CATEGORY_CONFIG_REQUEST';
export const FETCH_CATEGORY_CONFIG_SUCCESS = 'FETCH_CATEGORY_CONFIG_SUCCESS';
export const FETCH_CATEGORY_CONFIG_FAILURE = 'FETCH_CATEGORY_CONFIG_FAILURE';

export function fetchCategoryConfig(eventId) {
    return dispatch => {
        dispatch({ type: FETCH_CATEGORY_CONFIG_REQUEST });
        apiActionCreator(
            dispatch,
            () => events.getCategoryConfig(eventId),
            data => {
                dispatch({ type: FETCH_CATEGORY_CONFIG_SUCCESS, data });
                if (!data) {
                    dispatch(setModelData(MODELS.EVENT_CATEGORY_CONFIG, { categories: [] }));
                    return;
                }
                const transformedData = {
                    id: data.id,
                    eventId: data.eventId,
                    categories: (data.categories || []).map(category => ({
                        ...category,
                        labels: category.labels || []
                    }))
                };
                dispatch(setModelData(MODELS.EVENT_CATEGORY_CONFIG, transformedData));
            },
            error => {
                dispatch({ type: FETCH_CATEGORY_CONFIG_FAILURE, error });
                if (error.status === 404) {
                    dispatch(setModelData(MODELS.EVENT_CATEGORY_CONFIG, { categories: [] }));
                }
            }
        );
    };
}

export function saveCategoryConfig(eventId, data) {
    return dispatch => {
        const apiCall = () => events.updateCategoryConfig(eventId, data);

        apiActionCreator(
            dispatch,
            apiCall,
            result => {
                dispatch(openFlash('Category configuration successfully saved.'));
                if (!result) {
                    dispatch(setModelData(MODELS.EVENT_CATEGORY_CONFIG, { categories: [] }));
                    return;
                }
                const transformedData = {
                    id: result.id,
                    eventId: result.eventId,
                    categories: (result.categories || []).map(category => ({
                        ...category,
                        labels: category.labels || []
                    }))
                };
                dispatch(setModelData(MODELS.EVENT_CATEGORY_CONFIG, transformedData));
            },
            {
                allErrors: json => dispatch(openFlash(`Error saving category configuration: ${json.message}`, 'error'))
            }
        );
    };
}

export function fetchPartners(eventId, contextId) {
    return fetchDependencies([() => partners.getAllForEvent(eventId, contextId)], {
        append: true,
        sub: true
    });
}
